import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './FeatureRequest.css';
import { ClipLoader } from 'react-spinners'; // React spinner
import api from '../axiosConfig';
import { handleEmailSubmission } from './utils/emailService';

const FeatureRequest = () => {
    const [featureType, setFeatureType] = useState('');
    const [description, setDescription] = useState('');
    const [characterCount, setCharacterCount] = useState(0);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [userDetails, setUserDetails] = useState({ firstName: '', lastName: '', email: '' });
    const [errorMessage, setErrorMessage] = useState('');
    const maxDescriptionLength = 300; // Max character limit for description
    const navigate = useNavigate();

    // Fetch user details when the component mounts
    useEffect(() => {
        const fetchUserDetails = async () => {
            const token = localStorage.getItem('token');
            try {
                const response = await api.get('/userdata', {
                    headers: { Authorization: `Bearer ${token}` },
                });
                if (response.data.length > 0) {
                    const userData = response.data[0];
                    setUserDetails({
                        firstName: userData.firstName || '',
                        lastName: userData.lastName || '',
                        email: userData.email || '',
                    });
                }
            } catch (error) {
                console.error('Error fetching user details:', error);
                setErrorMessage('Failed to fetch user details. Please log in again.');
                navigate('/');
            }
        };
        fetchUserDetails();
    }, [navigate]);

    // Handle description field changes
    const handleDescriptionChange = (e) => {
        const value = e.target.value;
        if (value.length <= maxDescriptionLength) {
            setDescription(value);
            setCharacterCount(value.length);
            setErrorMessage(''); // Clear any previous error messages
        }
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setErrorMessage(''); // Clear any previous error messages

        const payload = {
            featureType,
            description,
            firstName: userDetails.firstName,
            lastName: userDetails.lastName,
            email: userDetails.email,
        };

        const { success, message } = await handleEmailSubmission('/send-email', payload);

        if (success) {
            alert('Your feature request has been submitted successfully!');
            navigate('/dashboard');
        } else {
            setErrorMessage(message);
        }

        setIsSubmitting(false);
    };



    return (
        <div className="feature-request-container">
            <h2>Feature Request</h2>
            {errorMessage && <p className="error-message">{errorMessage}</p>}
            <form onSubmit={handleSubmit} className="feature-request-form">
                <label htmlFor="featureType">Feature Type:</label>
                <select
                    id="featureType"
                    value={featureType}
                    onChange={(e) => setFeatureType(e.target.value)}
                    required
                >
                    <option value="" disabled>
                        Select a feature type
                    </option>
                    <option value="New Data">New Data</option>
                    <option value="UI Improvement">UI Improvement</option>
                    <option value="New Functionality">New Functionality</option>
                    <option value="Performance Optimization">Performance Optimization</option>
                    <option value="Other">Other</option>
                </select>

                <label htmlFor="description">Description:</label>
                <textarea
                    id="description"
                    value={description}
                    onChange={handleDescriptionChange}
                    rows="6"
                    required
                    placeholder="Please provide details about your feature request..."
                ></textarea>
                <p className="character-count">
                    {characterCount}/{maxDescriptionLength} characters
                </p>

                <button type="submit" className="submit-button" disabled={isSubmitting || !featureType || !description}>
                    {isSubmitting ? (
                        <>
                            <ClipLoader size={20} color="#ffffff" />
                            
                        </>
                    ) : (
                        'Submit'
                    )}
                </button>
            </form>
        </div>
    );
};

export default FeatureRequest;
